import { divideBy100, fromCurrency } from 'utils/currency';

import { CardTimeType, CardType } from './types';

const getFees = (percent: string, fixed: string, cards: CardTimeType[]) => {
  const tempCards: CardType[] = [];
  cards.forEach((c) => {
    const obj: CardType = {
      cardBrand: c.cardBrand,
      cardFunding: c.cardFunding,
      perc: divideBy100(Number(c.perc)),
      fixed: fromCurrency(c.fixed),
    };
    tempCards.push({ ...obj });
  });

  return {
    perc: divideBy100(Number(percent)),
    fixed: fromCurrency(fixed),
    cards: tempCards,
  };
};

export default getFees;
